export default "__VITE_ASSET__C26x3axS__"